import { FilterDescriptor } from "../data-table.component";
import { Sort } from "@angular/material/sort";
import { PageEvent } from "@angular/material/paginator";
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";

export type PageDescriptor = Partial<PageEvent>;
export type SortDescriptor = Sort;

export declare type Dictionary<T = string> = { [key: string]: T; };
export declare type ProviderOptions<T> = {
    terms?: Term<T>[];
    page?: Partial<PageDescriptor>;
    sort?: SortDescriptor;
    filter?: Partial<FilterDescriptor>;
};
export interface ITableDataSource<T = any> {
    data: T[]; //normalized, 
    readonly data$: Observable<T[]>;
    refresh(options?: { page?: PageDescriptor, sort?: SortDescriptor, filter?: FilterDescriptor }): Observable<T[]>;
    destroy?();
    readonly allDataLoaded: boolean; //so (filter/sort/group from client-side) true? false?

    init();
    page: PageDescriptor;
    sort: SortDescriptor;
    filter: FilterDescriptor;
    terms: Term<T>[];
}

export type Key<T> = keyof T | (keyof T)[];
export type NormalizedItem<T = any> = { key: any, item: T, display: Partial<T>, value: Partial<T>, image?: Partial<T>, defaultSearchTerm?: string }


export type Term<T> = { field: keyof T, type: 'string' | 'like' | 'number' | 'date' | 'boolean' };

export abstract class TableDataSource<T = any> implements ITableDataSource<T> {
    abstract readonly data: T[];
    abstract readonly data$: Observable<T[]>;
    abstract readonly allDataLoaded: boolean;

    abstract refresh();
    abstract destroy?();

    protected _initialized = false;
    init() {
        this._initialized = true;
        this.refresh();
    }

    readonly page$: BehaviorSubject<PageDescriptor> = new BehaviorSubject<PageDescriptor>({ pageIndex: 0 });
    get page(): PageDescriptor { return this.page$.value; }
    set page(page: PageDescriptor) { this.page$.next(page); if (this._initialized) this.refresh(); }

    readonly sort$: BehaviorSubject<SortDescriptor> = new BehaviorSubject<SortDescriptor>(null);
    get sort(): SortDescriptor { return this.sort$.value; }
    set sort(sort: SortDescriptor) { this.sort$.next(sort); if (this._initialized) this.refresh(); }

    readonly filter$: BehaviorSubject<FilterDescriptor> = new BehaviorSubject<FilterDescriptor>({});
    get filter(): FilterDescriptor { return this.filter$.value; }
    set filter(filter: FilterDescriptor) {
        this.filter$.next(filter);
        this.page.pageIndex = 0;
        if (this._initialized)
            this.refresh();
    }




    readonly terms$: BehaviorSubject<Term<T>[]> = new BehaviorSubject<Term<T>[]>([]);
    get terms(): Term<T>[] { return this.terms$.value; }
    set terms(terms: Term<T>[]) {
        this.terms$.next(terms);
        if (this._initialized)
            this.refresh();
    }



}